<template>
  <transition name="content">
    <template v-if="newMode">
      <header>
        <div class="container-fluid">
          <div class="row">
            <div class="logo border-right">
              <a href="/"><img :src="require('@/assets/images/logo.png')" alt="saad"></a>
            </div>
            <div class="search">

              <form action="">
                <i class="fa fa-search"></i>
                <input type="text" name="q" placeholder="Search for project here">
              </form>
            </div>
            <div class="user">
              <div class="user-details">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-7 text-right">
                      <div class="name">
                        <router-link tag="a" :to="{'name': 'users.profile', 'params': {'oid': $store.getters.userId}}">{{ $formatter.formatUser(userName) }}</router-link>
                      </div>
                      <div class="job" style="padding-top: 10px;"><a @click.prevent="logoutRedirect"><i class="icon-switch2"></i> Logout</a></div>
                    </div>
                    <div class="col-xs-5">
                      <img v-if="user.profile.logo" :src="user.profile.logo.preview" :alt="$formatter.formatUser(userName)">
                      <img v-else :src="require('@/assets/images/avatar.jpg')" :alt="$formatter.formatUser(userName)">
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="navicon visible-xs">
              <i class="glyphicon glyphicon-align-justify"></i>
            </div>

            <div class="notifications border-right border-left text-center">
              <li class="dropdown" style="list-style: none">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-bell"></i>
                </a>

                <div class="dropdown-menu dropdown-content dropdown-menu-right">
                  <ul class="media-list dropdown-content-body width-350">
                    <template class="media" v-for="(notification, idx) in notifications.list">
                      <li class="media" :key="idx" v-if="notification.html">
                        <div class="media-left">
                          <a href="#" class="btn bg-purple-300 btn-rounded btn-icon btn-xs"><i class="icon-coins"></i></a>
                        </div>
                        <div class="media-body">
                          <span v-html="notification.html"></span>
                          <div class="media-annotation">{{notification.created_at | moment(localizedFormat.fullDate)}}</div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </li>
            </div>
          </div>
        </div>
      </header>
    </template>
    <template v-else>
      <!-- Main navbar -->
      <div class="navbar navbar-default navbar-fixed-top">
        <div class="navbar-header text-center">
          <a class="navbar-brand" style="padding: 2px; padding-bottom: 5px; float: none;" href="/"><img style="max-height: 50px; height: 100%; display: inline;" src="//saad.thirty3.tools/images/logo.jpg" alt=""></a>

          <ul class="nav navbar-nav visible-xs-block">
            <li><a data-toggle="collapse" data-target="#navbar-mobile"><i class="icon-tree5"></i></a></li>
            <li><a class="sidebar-mobile-main-toggle"><i class="icon-paragraph-justify3"></i></a></li>
            <li><a class="sidebar-mobile-secondary-toggle" style="display: none"><i class="icon-more"></i></a></li>
          </ul>
        </div>

        <div class="navbar-collapse collapse" id="navbar-mobile">
          <ul class="nav navbar-nav">
            <li><a @click.prevent="toggleSidebar()" class="sidebar-control sidebar-main-toggle hidden-xs"><i class="icon-paragraph-justify3"></i></a></li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <i class="icon-puzzle3"></i>
                <span class="visible-xs-inline-block position-right">Document updates</span>
                <span class="status-mark border-pink-300"></span>
              </a>

              <div class="dropdown-menu dropdown-content">
                <div class="dropdown-content-heading">
                  Apartment updates
                  <ul class="icons-list">
                    <li><a href="#"><i class="icon-sync"></i></a></li>
                  </ul>
                </div>

                <ul class="media-list dropdown-content-body width-350">
                  <li class="media">
                    <div class="media-left">
                      <a href="#" class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm"><i class="icon-cancel-circle2"></i></a>
                    </div>

                    <div class="media-body">
                      Apartment <a href="#">#D2345</a> reserved by Agent
                      <div class="media-annotation">4 minutes ago</div>
                    </div>
                  </li>

                  <li class="media">
                    <div class="media-left">
                      <a href="#" class="btn border-warning text-warning btn-flat btn-rounded btn-icon btn-sm"><i class="icon-check2"></i></a>
                    </div>

                    <div class="media-body">
                      Apartment <a href="#">#S001</a> was released from reservation.
                      <div class="media-annotation">36 minutes ago</div>
                    </div>
                  </li>

                </ul>

                <div class="dropdown-content-footer">
                  <a href="#" data-popup="tooltip" title="All activity"><i class="icon-menu display-block"></i></a>
                </div>
              </div>
            </li>
            <li><a @click.prevent="()=>{}">SAAD Agency Sales CRM</a></li>
          </ul>

          <div class="navbar-right" v-if="material">
            <p class="navbar-text">{{ helloTime }}, {{ userName }}!</p>
            <p class="navbar-text"><span class="label bg-success">Online</span></p>
          </div>
          <ul v-else class="nav navbar-nav navbar-right">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <i class="icon-bell2"></i>
                <span class="visible-xs-inline-block position-right">Activity</span>
                <span class="status-mark border-pink-300"></span>
              </a>

              <div class="dropdown-menu dropdown-content">
                <div class="dropdown-content-heading">
                  Activity
                  <ul class="icons-list">
                    <li><a href="#"><i class="icon-menu7"></i></a></li>
                  </ul>
                </div>

                <ul class="media-list dropdown-content-body width-350">

                  <li class="media" v-for="(notification, idx) in notifications.list" :key="idx">
                    <div class="media-left">
                      <a href="#" class="btn bg-purple-300 btn-rounded btn-icon btn-xs"><i class="icon-coins"></i></a>
                    </div>

                    <div class="media-body">
                      <span v-html="notification.html"></span>
                      <div class="media-annotation">{{notification.created_at | moment(localizedFormat.fullDate)}}</div>
                    </div>
                  </li>
                </ul>
                <div class="dropdown-content-footer">
                  <a href="#" data-popup="tooltip" title="All activity"><i class="icon-menu display-block"></i></a>
                </div>
              </div>
            </li>
            <li class="dropdown dropdown-user">
              <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                <span>{{ helloTime }}, <strong>{{ $formatter.formatUser(userName) }}</strong></span>
                <i class="caret"></i>
              </a>

              <ul class="dropdown-menu dropdown-menu-right">
                <li>
                  <router-link tag="a" :to="{'name': 'users.profile', 'params': {'oid': $store.getters.userId}}"><i class="icon-user-plus"></i> My profile</router-link>
                </li>
                <li class="divider"></li>
                <li><a @click.prevent="logoutRedirect"><i class="icon-switch2"></i> Logout</a></li>
              </ul>
            </li>
          </ul>

        </div>
      </div>
      <!-- /main navbar -->
    </template>
  </transition>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'

export default {
  name: 'Navbar',
  props: ['material', 'newMode', 'user'],

  data () {
    return {
      localizedFormat: {}
    }
  },

  mounted () {
    this.localizedFormat = Vue.config.localizedFormat
  },

  computed: {
    helloTime: () => {
      let data = [
        [0, 4, 'Good night'],
        [5, 11, 'Good morning'], // Store messages in an array
        [12, 17, 'Good afternoon'],
        [18, 21, 'Good evening'],
        [22, 24, 'Good night']
      ]
      let hr = new Date().getHours()

      for (let i = 0; i < data.length; i++) {
        if (hr >= data[i][0] && hr <= data[i][1]) {
          return data[i][2]
        }
      }
      return 'Hello'
    },
    ...Vuex.mapGetters(['userName', 'isSidebarFull', 'notifications'])
  },
  methods: {
    ...Vuex.mapActions(['logout']),

    logoutRedirect () {
      // Force vuex reset with $router.go
      this.logout().then(() => this.$router.replace({ name: 'login' }))
    },

    toggleSidebar () {
      this.$store.dispatch('toggleSidebar')
    }
  }
}
</script>

<style scoped>

</style>
